import { Lock } from '@/components/Lock';
import { TPage } from '@/types';
import { Typography } from '@data-products-and-ai/react-components';

import lobby from '@/assets/places/lobby.jpg';

const LockerRoom = ({ team, target }: TPage) => {
  return (
    <Lock
      hasLogo={false}
      target={target}
      combination="209"
      text={
        <Typography>
          <div style={{ marginBottom: 20 }}>
            <img src={lobby} alt="" style={{ width: 300, height: 'auto' }} />
          </div>
          Cats are constantly challenge with new tasks and they always come up
          with the right answer.
          <br />
          <br />
          Find this room and then run:
          <br />
          <code>
            SELECT COUNT(*) AS code FROM lockers WHERE id BETWEEN 3 AND 112 AND
            toplabel = {`'`}E1-P1{`'`}
          </code>
        </Typography>
      }
    />

    /*   <Lock
      target={target}
      lockType="image"
      combination="3,0,2,1,4,5,7,6,9,8"
      text={
        <Typography tag="h1">
          Great job so fAr but aRe you All aGain prEpared? Go aROUND the message
          and Find aLl yOu need tO be in the Right path!
        </Typography>
      }
    /> */
  );
};

export default LockerRoom;
